import { FolderGrid } from './FolderGrid';
import { FileGrid } from './FileGrid';
import { Stack } from '@mui/material';

export const FileSelectorGrid = (props) => {
  const { callbacks, items = [], selectedFile, showActions = false } = props;
  const { toggleSelectedFile, toggleSelectedFolder, deleteFile, downloadFile } = callbacks;

  const folders = items?.filter((item) => item?.format === 'Folder');
  const files = items?.filter((item) => item?.format === 'File');

  return (
    <Stack
      spacing={2}
      pt={1.5}
    >
      {folders?.length > 0 && (
        <FolderGrid
          folders={folders}
          callbacks={{ handleSelectFolder: (folder) => toggleSelectedFolder(folder) }}
        />
      )}
      {files?.length > 0 && (
        <FileGrid
          files={files}
          selectedFile={selectedFile}
          showActions={showActions}
          callbacks={{
            handleSelectFile: (file) => toggleSelectedFile(file),
            handleDeleteFile: (file) => deleteFile(file),
            handleDownloadFile: (file) => downloadFile(file),
          }}
        />
      )}
    </Stack>
  );
};
